howspace.components.workspacePicker = (() => {
    'use strict';

    const searchWorkspaces = e => {
        const workspaceSearchInput = $(e.currentTarget);
        const dropdown = workspaceSearchInput.closest('.dropdown');
        const workspacePicker = workspaceSearchInput.closest('.howspace-workspace-picker');
        const search = e.detail.value;

        if (search === '' && workspaceSearchInput[0].dataset.allowEmpty !== 'true') {
            howspace.components.dropdown.close(dropdown);
            return;
        }

        real.ajax.json(real.baseUri + workspacePicker.data('search-url') + '?search=' + encodeURIComponent(search) + '&sort_by=name', {
            type: 'GET',
            success: response => {
                if (response.search !== undefined && response.search !== workspaceSearchInput.val().trim()) {
                    // discard the results since the search input value has changed since the request was sent
                    return;
                }
                let html = response.table_html;
                if (html.trim() === '') {
                    html = '<div class="p-3">' + howspace.translate('common_no_workspaces_were_found') + '</div>';
                }
                const menu = workspacePicker.find('.howspace-menu');
                menu.removeClass('d-none');
                menu.find('.menu-items').html(html);
                howspace.components.init(workspacePicker);
                howspace.components.dropdown.open(dropdown);
            }
        });
    };

    const selectWorkspace = e => {
        const btn = $(e.currentTarget);
        const workspacePicker = btn.closest('.howspace-workspace-picker');
        const workspaceSearchInput = workspacePicker.find('.howspace-form-search-input');

        const workspaceName = btn.data('workspace-name');
        workspaceSearchInput.val(workspaceName);
        workspaceSearchInput.prop('readonly', true);

        const workspaceId = btn.data('workspace-id');
        workspacePicker.find('input[type="hidden"]').val(workspaceId);
    };

    const clearWorkspace = e => {
        const btn = $(e.currentTarget);
        const workspacePicker = btn.closest('.howspace-workspace-picker');
        const workspaceSearchInput = workspacePicker.find('.howspace-form-search-input');

        workspaceSearchInput.prop('readonly', false);

        workspacePicker.find('input[type="hidden"]').val('');
    };

    return {
        init: elem => {
            elem.findIncludingSelf('.howspace-workspace-picker:not(.howspace-workspace-picker-initialized)').each(function () {
                const workspacePicker = $(this);
                workspacePicker.addClass('howspace-workspace-picker-initialized');
                const dropdown = workspacePicker.find('.dropdown');
                dropdown.on('click', '[role="menuitem"]', selectWorkspace);
                const workspaceSearchInput = dropdown.find('.howspace-form-search-input');
                workspaceSearchInput.on(howspace.components.searchInput.SEARCH, searchWorkspaces);
                workspacePicker.find('.clear-search-btn').on('click', clearWorkspace);
            });
        },
        destroy: elem => {
            elem.findIncludingSelf('.howspace-workspace-picker.howspace-workspace-picker-initialized').each(function () {
                const workspacePicker = $(this);
                workspacePicker.removeClass('howspace-workspace-picker-initialized');
                const dropdown = workspacePicker.find('.dropdown');
                dropdown.off('click', '[role="menuitem"]', selectWorkspace);
                const workspaceSearchInput = dropdown.find('.howspace-form-search-input');
                workspaceSearchInput.off(howspace.components.searchInput.SEARCH, searchWorkspaces);
                workspacePicker.find('.clear-search-btn').off('click', clearWorkspace);
            });
        }
    };
})();
